.tag { display: inline-flex; align-items: center; gap: 5px; padding: 4px 8px; border: 1px solid var(--ink); font-family: var(--font-mono); font-size: 9px; letter-spacing: 1px; line-height: 1; white-space: nowrap; color: var(--paper); }
/* Ride's pink is light, so its icon and label stay ink. */
.tag[data-sport='ride'] { color: var(--ink); }
